module.exports = __webpack_public_path__ + "img/pole.c72c4a15.gif";